import MaintenanceCategoriesDialog
  from "@/views/settings/maintenanceManagement/maintenanceCategoriesDialog/MaintenanceCategoriesDialog.vue";
import {MaintenanceCategory} from "@/models/maintenance/MaintenanceCategory";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";

export default {
  name: "MaintenanceCategories",
  components: {
    ConfirmDlg,
    MaintenanceCategoriesDialog,
  },
  data() {
    return {
      loading: true,
      headers: [
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
          align: "start",
          value: "name",
        },
        {
          align: "end",
          value: "id",
          sortable: false
        }
      ]
    }
  },
  computed: {
    maintenanceCategories(): MaintenanceCategory[] {
      return this.$store.state.maintenanceModule.maintenanceCategories;
    }
  },
  methods: {
    addMaintenanceCategory() {
      this.$refs.maintenanceCategoriesDialog.open('add')
    },
    updateMaintenanceCategory(item) {
      this.$refs.maintenanceCategoriesDialog.open('update', item)
    },
    deleteMaintenanceCategory(item) {
      this.$refs.confirmDlg
        .open(null, this.$i18n.messages[this.$i18n.locale]['MaintenanceManagement.DeleteMaintenanceType'].replace('[name]',item.name), false, '', { noButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Cancel'], yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Delete'] })
        .then(async response => {
          if (response && response.agree) {
            await this.$store.dispatch("deleteMaintenanceCategory", item).then(async () => {
              this.$toast.open({
                message: this.$i18n.messages[this.$i18n.locale]['MaintenanceManagement.MaintenanceCategorySuccessDeleted'],
                type: "success"
              });
            })
          }
        });
    }
  },
  async created() {
      await this.$store.dispatch("getMaintenanceCategories");
      this.loading = false;
  }
}